import {
	Button,
	HStack,
	Input,
	Text,
} from '@montel/montelpro-shared-components-v2';
import { RequestStatus } from '@montel/montelpro-shared-components/enums';
import { DEVELOPER_API_SYNC_ACCOUNT_FROM_FUSIONAUTH } from 'apiRoutes';
import useSubmit, { POST } from 'hooks/useSubmit';
import { FunctionComponent, useState } from 'react';

const FusionAuthSyncTool: FunctionComponent = () => {
	const [accountId, setAccountId] = useState<string>('');

	const [submit, status] = useSubmit(
		`${DEVELOPER_API_SYNC_ACCOUNT_FROM_FUSIONAUTH}`,
		POST,
		{
			messageOnSuccess: 'Account synced from FusionAuth',
			messageOnError: 'Error syncing account',
			showApiError: true,
		},
	);

	const onSubmit = async () => {
		await submit({
			accountId: accountId,
		});
	};

	return (
		<>
			<Text>Sync account from FusionAuth</Text>
			<HStack wrap="nowrap">
				<Input
					label="Account id"
					type="text"
					autoComplete="off"
					name="accountId"
					value={accountId}
					required
					onChange={(event) => setAccountId(event.target.value)}
				/>
			</HStack>
			<Button
				onClick={onSubmit}
				type="submit"
				text="Sync"
				loadingText="Syncing account ..."
				isLoading={status === RequestStatus.LOADING}
			/>
		</>
	);
};

export default FusionAuthSyncTool;
